var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valid)?_c('div',[_c('b',[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v("("+_vm._s(_vm.cin)+")")]),_c('br'),_c('em',[_vm._v(_vm._s(_vm.country))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }